import { createAction, props } from '@ngrx/store';
import { ElementRef } from '@angular/core';
import { ScreenSize } from 'app/models/common/screenSize';

export const setTotalScreenSize = createAction('[Layout] Set Total Screen Size', props<{ totalScreenSize: ScreenSize }>());
export const setTotalWindowWidth = createAction('[Layout] Set Total Window Width', props<{ totalWindowWidth: number }>());
export const setTotalWindowHeight = createAction('[Layout] Set Total Window Height', props<{ totalWindowHeight: number }>());
export const setSidenavOpened = createAction('[Layout] Set Sidenav Opened', props<{ sidenavOpened: boolean }>());
export const setPopoverWidth = createAction('[Layout] Set Popover Width', props<{ popoverWidth: number }>());
export const setPopoverDocked = createAction('[Layout] Set Popover Docked', props<{ popoverDocked: boolean }>());
export const setToolbarZindex = createAction('[Layout] Set Toolbar Zindex', props<{ toolbarZindex: number }>());
export const setGlobalReference = createAction('[Layout] Set Global Reference', props<{ globalReference: ElementRef }>());


